const NumberHelper = {
    padStartNumber: (num) => num?.toString().padStart(2, '0'),
};

export default NumberHelper;
